<template>
	<page :title="isEditMode ? 'updateCompetitionTitle' : 'newCompetitionTitle'" :textHeight="(WindowSize.y - 276) + 'px'">
		<template #pageContainer>
			<form>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:label="$t('text.name')"
						v-model="form.name"
						:error-messages="nameErrors"
						required
						@input="$v.form.name.$touch()"
						@blur="$v.form.name.$touch()">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:label="$t('text.gerCompetitionId')"
						v-model="form.germanCompetitionId">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-menu v-model="menuFrom" :close-on-content-click="false" max-width="290">
						<template #activator="{ on }">
							<v-text-field outlined dense
								hide-details="auto"
								class="mt-0 pt-0"
								:value="FormattedDateFrom"
								:error-messages="dateFromErrors"
								clearable
								:label="$t('text.dateFrom')"
								readonly
								v-on="on"
								@click:clear="form.dateFrom = null"
								required
								@change="resetEnvironment()"
								@input="$v.form.dateFrom.$touch()"
								@blur="$v.form.dateFrom.$touch()">
							</v-text-field>
						</template>
						<v-date-picker locale="DE-de" v-model="form.dateFrom" @change="menuFrom = false; resetEnvironment();">
						</v-date-picker>
					</v-menu>
				</v-col></v-row>
				<v-row><v-col>
					<v-menu v-model="menuTo" :close-on-content-click="false" max-width="290">
						<template #activator="{ on }">
							<v-text-field outlined dense
								hide-details="auto"
								class="mt-0 pt-0"
								:value="FormattedDateTo"
								clearable
								:label="$t('text.dateTo')"
								readonly
								:error-messages="dateToErrors"
								v-on="on"
								@click:clear="form.dateTo = null"
								required
								@input="$v.form.dateTo.$touch()"
								@blur="$v.form.dateTo.$touch()">
							</v-text-field>
						</template>
						<v-date-picker locale="DE-de" v-model="form.dateTo" @change="menuTo = false">
						</v-date-picker>
					</v-menu>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense :label="$t('text.stadionName')" v-model="form.location"
						hide-details="auto">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:label="$t('text.town')"
						v-model="form.town"
						:error-messages="townErrors"
						required
						@input="$v.form.town.$touch()"
						@blur="$v.form.town.$touch()">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-autocomplete outlined dense
						hide-details="auto"
						v-model="form.nation"
						:items="nationsList"
						:error-messages="nationErrors"
						required
						:label="$t('text.nation')"
						@input="$v.form.nation.$touch()"
						@blur="$v.form.nation.$touch()">
					</v-autocomplete>
				</v-col></v-row>
				<v-row><v-col>
					<v-autocomplete outlined dense
						hide-details="auto"
						v-model="form.environment"
						:items="environmentList"
						:error-messages="environmentErrors"
						required
						:label="$t('text.environment')"
						@input="$v.form.environment.$touch()"
						@blur="$v.form.environment.$touch()">
					</v-autocomplete>
				</v-col></v-row>
				<v-row><v-col>
					<!-- <v-text-field outlined dense :label="$t('text.stateCode')" v-model="form.stateCode"
							hide-details="auto"></v-text-field> -->
					<v-autocomplete outlined dense
						hide-details="auto"
						class="mt-0 pt-0"
						clearable
						v-model="regionGuid.selected"
						:items="regionGuid.items"
						return-object
						:label="$t('text.stateAssociation')">
					</v-autocomplete>
				</v-col></v-row>
				<v-row><v-col>
					<!-- <v-text-field outlined dense :label="$t('text.area')" v-model="form.area"
							hide-details="auto"></v-text-field> -->
					<v-autocomplete outlined dense
						hide-details="auto"
						:disabled="!regionGuid.selected || areaGuid.items.length === 0"
						class="mt-0 pt-0"
						clearable
						v-model="form.area"
						:items="areaGuid.items"
						item-value="text"
						:label="$t('text.area')">
					</v-autocomplete>
				</v-col></v-row>
				<v-row><v-col>
					<!-- <v-text-field outlined dense :label="$t('text.district')" v-model="form.district"
							hide-details="auto"></v-text-field> -->
					<v-autocomplete outlined dense
						hide-details="auto"
						:disabled="!regionGuid.selected || districtGuid.items.length === 0"
						class="mt-0 pt-0"
						clearable
						v-model="form.district"
						:items="districtGuid.items"
						item-value="text"
						:label="$t('text.district')">
					</v-autocomplete>
				</v-col></v-row>
			</form>
			<spinner :loading="loading"></spinner>
		</template>
		<template #pageActions>
			<v-row><v-col>
				<v-btn
					class="mr-4"
					:disabled="$v.$invalid || loading"
					@click="create">
					<template v-if="!isEditMode">{{ $t(`text.createButton`) }}</template>
					<template v-else>{{ $t(`text.updateButton`) }}</template>
				</v-btn>
					<!-- <v-btn
					class="mr-4"
					:disabled="$v.$invalid || loading"
					@click="update">
					{{ $t(`text.updateButton`) }}
				</v-btn> -->
				<v-btn :disabled="loading" class="mr-4" @click="back">
					{{ $t(`text.backButton`) }}
				</v-btn>
				</v-col>
			</v-row>
		</template>
	</page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';

import Page from '../general/Page.vue';
import Spinner from '../general/Spinner.vue';

import competitionActions from '../store/actions/competition';
import organizationActions from '../store/actions/organization';
import namespace from '../store/namespace';

import modelState from '../mixins/modelState';
import getEnvList from '../models/environment';
import getIOC from '../models/IOC';

export default {
	name: 'NewCompetition',
	mixins: [modelState],
	components: {
		Page,
		Spinner,
	},
	validations: {
		form: {
			name: {
				required,
			},
			dateFrom: {
				required,
			},
			dateTo: {
				required,
			},
			town: {
				required,
			},
			nation: {
				required,
			},
			environment: {
				required,
			},
		},
	},
	data() {
		return {
			form: {
				name: null,
				germanCompetitionId: null,
				dateFrom: null,
				dateTo: null,
				town: null,
				location: null,
				nation: null,
				environment: 1,
				area: null,
				district: null,
				stateCode: null,
			},
			menuFrom: false,
			menuTo: false,
			loading: false,
			regionGuid: {
				loading: false,
				items: [],
				selected: null,
			},
			areaGuid: {
				loading: false,
				items: [],
			},
			districtGuid: {
				loading: false,
				items: [],
			},
			id: this.$route.params.id,
		};
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.COMPETITION, ['Links', 'Entities']),
		...mapGetters(namespace.ORGANIZATION, ['ExternalId']),
		...mapGetters(namespace.USER, ['User']),
		nationsList() {
			return getIOC();
		},
		environmentList() {
			return getEnvList(this);
		},
		nameErrors() {
			const errors = [];

			if (!this.$v.form.name.$dirty) return errors;

			const apiErrors = this.validateProperty('Name');

			if (apiErrors.length > 0) {
				errors.push(apiErrors);
			}

			!this.$v.form.name.required
				&& errors.push(this.$i18n.t('text.errorNameRequired'));

			return errors;
		},
		dateFromErrors() {
			const errors = [];

			if (!this.$v.form.dateFrom.$dirty) return errors;

			const apiErrors = this.validateProperty('DateFrom');

			if (apiErrors.length > 0) {
				errors.push(apiErrors);
			}

			!this.$v.form.dateFrom.required
				&& errors.push(this.$i18n.t('text.errorDateFromRequired'));

			return errors;
		},
		dateToErrors() {
			const errors = [];

			if (!this.$v.form.dateTo.$dirty) return errors;

			const apiErrors = this.validateProperty('DateTo');

			if (apiErrors.length > 0) {
				errors.push(apiErrors);
			}

			!this.$v.form.dateTo.required
				&& errors.push(this.$i18n.t('text.errorDateToRequired'));

			return errors;
		},
		townErrors() {
			const errors = [];

			if (!this.$v.form.town.$dirty) return errors;

			const apiErrors = this.validateProperty('Town');

			if (apiErrors.length > 0) {
				errors.push(apiErrors);
			}

			!this.$v.form.town.required
				&& errors.push(this.$i18n.t('text.errorTownRequired'));

			return errors;
		},
		nationErrors() {
			const errors = [];

			if (!this.$v.form.nation.$dirty) return errors;

			const apiErrors = this.validateProperty('Nation');

			if (apiErrors.length > 0) {
				errors.push(apiErrors);
			}

			!this.$v.form.nation.required
				&& errors.push(this.$i18n.t('text.errorNationRequired'));

			return errors;
		},
		environmentErrors() {
			const errors = [];

			if (!this.$v.form.environment.$dirty) return errors;

			const apiErrors = this.validateProperty('Environment');

			if (apiErrors.length > 0) {
				errors.push(apiErrors);
			}

			!this.$v.form.environment.required
				&& errors.push(this.$i18n.t('text.errorEnvironmentRequired'));

			return errors;
		},
		FormattedDateFrom() {
			return this.form.dateFrom ? this.$moment(this.form.dateFrom).format('DD.MM.YYYY') : '';
		},
		FormattedDateTo() {
			return this.form.dateTo ? this.$moment(this.form.dateTo).format('DD.MM.YYYY') : '';
		},
		isEditMode() {
			return !!this.id;
		},
	},
	async mounted() {
		if (this.Links.length === undefined || this.Links.length === 0) {
			await this.GET_COMP_LINKS();
		}
		if (this.isEditMode && this.id) {
			await this.getCompetition();
		}
		this.getRegionOrganization();
	},
	watch: {
		'regionGuid.selected': function () {
			this.form.stateCode = this.regionGuid.selected.text;
			this.getAreaOrganization();
			this.getDistrictOrganization();
		},
	},
	methods: {
		...mapActions(namespace.COMPETITION, [
			competitionActions.CREATE_NEW_COMPETITION,
			competitionActions.GET_COMP_LINKS,
			competitionActions.GET_COMPETITION_BY_ID,
			competitionActions.FULL_UPDATE_COMPETITION,
		]),
		...mapActions(namespace.ORGANIZATION, [
			organizationActions.GET_ORGANIZATIONS_BY_TYPE,
			organizationActions.GET_ORGANIZATIONS_BY_TYPE_PARENT,
		]),
		async create() {
			this.loading = true;
			this.$v.$touch();

			if (!this.$v.$invalid) {
				const link = this.isEditMode ? this.Links.find(x => x.rel === 'update') : this.Links.find(x => x.rel === 'new');

				if (link) {
					try {
						this.modelState = {};

						const perfComp = this.form;
						if (this.isEditMode) {
							perfComp.id = this.id;
							perfComp.lastEditorUserId = this.User.id;
							await this.FULL_UPDATE_COMPETITION({ perfComp, link });
						} else {
							perfComp.importSource = 'portal';
							perfComp.ownerId = this.ExternalId;
							perfComp.creatorUserId = this.User.id;
							await this.CREATE_NEW_COMPETITION({ perfComp, link });
						}

						this.back();
					} catch (e) {
						if (e.response != undefined && e.response.status === 422) {
							this.modelState = e.response.data;
							if (this.modelError()) {
								throw new Error(this.modelError());
							}
						}

						throw e;
					} finally {
						this.loading = false;
					}
				}
			}
			this.loading = false;
		},
		back() {
			this.$router.go(-1);
		},
		async getCompetition() {
			this.loading = true;
			try {
				const competition = await this.GET_COMPETITION_BY_ID(this.id);

				if (competition) {
					this.form = competition;

					this.form.dateFrom = competition.dateFrom.substr(0, 10);
					this.form.dateTo = competition.dateTo.substr(0, 10);

					delete this.form.links;
					delete this.form.importSource;
				}
			} finally {
				this.loading = false;
			}
		},
		async getRegionOrganization() {
			this.regionGuid.loading = true;
			this.regionGuid.items = await this.GET_ORGANIZATIONS_BY_TYPE('Region');
			if (this.form.stateCode != null) {
				this.regionGuid.selected = this.regionGuid.items.find(x => x.text == this.form.stateCode);
			}
			this.regionGuid.loading = false;
		},
		async getAreaOrganization() {
			if (!this.regionGuid.selected) return;
			this.areaGuid.loading = true;
			this.areaGuid.items = await this.GET_ORGANIZATIONS_BY_TYPE_PARENT({ type: 'Area', parent: this.regionGuid.selected.value });
			if (this.form.area != null) {
				this.areaGuid.selected = this.areaGuid.items.find(x => x.text == this.form.area).value;
			}
			this.areaGuid.loading = false;
		},
		async getDistrictOrganization() {
			if (!this.regionGuid.selected) return;
			this.districtGuid.loading = true;
			this.districtGuid.items = await this.GET_ORGANIZATIONS_BY_TYPE_PARENT({ type: 'District', parent: this.regionGuid.selected.value });
			if (this.form.district != null) {
				this.districtGuid.selected = this.districtGuid.items.find(x => x.text == this.form.district).value;
			}
			this.districtGuid.loading = false;
		},
		// async update() {
		// 	this.loading = true;
		// 	this.$v.$touch();

		// 	if (!this.$v.$invalid) {
		// 		const link = this.Links.find(x => x.rel === 'update');

		// 		if (link) {
		// 			const editedPerfComp = this.form;
		// 			editedPerfComp.id = this.id;

		// 			try {
		// 				this.modelState = {};

		// 				await this.FULL_UPDATE_COMPETITION({ editedPerfComp, link });

		// 				this.back();
		// 			} catch (e) {
		// 				if (e.response.status === 422) {
		// 					this.modelState = e.response.data;
		// 					if (this.modelError()) {
		// 						throw new Error(this.modelError());
		// 					}
		// 				}

		// 				throw e;
		// 			} finally {
		// 				this.loading = false;
		// 			}
		// 		}
		// 	}
		// 	this.loading = false;
		// },
		resetEnvironment() {
			if (typeof this.form.dateFrom === 'string') {
				const month = this.$moment(this.form.dateFrom).toDate().getMonth();
				if (month <= 2 || month >= 10) {
					this.form.environment = 0;
				} else {
					this.form.environment = 1;
				}
			}
		},
		dateToHandler(date) {
			if (typeof date === 'string') {
				this.form.dateTo = this.$moment(date).toDate();
			}

			this.form.dateTo = date;
		},
		dateFromHandler(date) {
			if (typeof date === 'string') {
				this.form.dateFrom = this.$moment(date).toDate();
			}

			this.form.dateFrom = date;
		},
	},
};
</script>
